import MomentUtils from "@date-io/moment";
import { Divider, FormControl, Grid, Paper, Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import "moment/locale/en-ca";
import "moment/locale/vi";
import React, { Component } from "react";
import { translate } from "react-i18next";
import InputFormat from "../../../partials/inputForm";
import LabelForm from "../../../partials/labelForm";
import { getNumberOnString } from "../../../partials/validateNumber";
import NumberFormatCustom from "../../numberFormat";
import { style } from "./styles";

class Inventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: this.props.product || {},
    };
  }
  async componentDidMount() {}
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.product && nextProps.product.id !== this.state.product.id)
      this.setState({
        product: nextProps.product,
      });
  };
  handleChange = (e) => {
    let { product } = this.state;
    let name = e.target.name;
    let value = e.target.value;
    if (e.target.type === "checkbox") value = e.target.checked;
    else if (name === "stock_quantity") value = getNumberOnString(value);
    product[name] = value;
    this.setState(product);
  };
  handleChangePickerDate = (value, nameInput) => {
    let { product } = this.state;
    product[nameInput] = value.valueOf();
    this.setState(product);
  };
  render() {
    const { classes, t, i18n } = this.props;
    let { product } = this.state;
    return (
      <MuiPickersUtilsProvider
        libInstance={moment}
        utils={MomentUtils}
        locale={i18n.language === "vn" ? "vi" : "en"}
      >
        <Paper className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <LabelForm label={t("product_pricing")} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <InputFormat
                    label={t("product_regular_price")}
                    name="regular_price"
                    value={product.regular_price}
                    onChange={this.handleChange}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <InputFormat
                    label={t("product_sale_price")}
                    name="sale_price"
                    value={product.sale_price}
                    onChange={this.handleChange}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <FormControl className={classes.formControl}>
                    <KeyboardDatePicker
                      autoOk
                      name="date_sale_from"
                      inputVariant="outlined"
                      label={t("product_sale_from")}
                      format="DD/MM/YYYY"
                      value={this.state.date_sale_from}
                      views={["year", "month", "date"]}
                      onChange={(date) =>
                        this.handleChange({
                          target: {
                            value: new Date(date.valueOf()).toISOString(),
                            name: "date_sale_from",
                          },
                        })
                      }
                      cancelLabel={t("date_picker_cancel")}
                      okLabel={t("date_picker_ok")}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <FormControl className={classes.formControl}>
                    <KeyboardDatePicker
                      autoOk
                      margin="none"
                      name="date_sale_to"
                      inputVariant="outlined"
                      label={t("product_sale_to")}
                      format="DD/MM/YYYY"
                      value={this.state.date_sale_to}
                      views={["year", "month", "date"]}
                      onChange={(date) =>
                        this.handleChange({
                          target: {
                            value: new Date(date.valueOf()).toISOString(),
                            name: "date_sale_to",
                          },
                        })
                      }
                      cancelLabel={t("date_picker_cancel")}
                      okLabel={t("date_picker_ok")}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <LabelForm label={t("product_inventory")} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <InputFormat
                    label={t("product_sku")}
                    name="sku"
                    value={product.sku}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <InputFormat
                    label={t("product_stock_quantity")}
                    name="stock_quantity"
                    value={product.stock_quantity}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <InputFormat
                    label={t("product_stock_weight") + " (kg)"}
                    name="weight"
                    value={product.weight}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <FormControl className={classes.formControl}>
                    <KeyboardDatePicker
                      autoOk
                      name="date_stock_expected"
                      inputVariant="outlined"
                      label={t("product_expected_date")}
                      format="DD/MM/YYYY"
                      value={this.state.date_stock_expected}
                      views={["year", "month", "date"]}
                      onChange={(date) =>
                        this.handleChange({
                          target: {
                            value: new Date(date.valueOf()).toISOString(),
                            name: "date_stock_expected",
                          },
                        })
                      }
                      cancelLabel={t("date_picker_cancel")}
                      okLabel={t("date_picker_ok")}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <div className={classes.containerSwitch}>
                    <LabelForm label={t("product_manage_stock")} />
                    <Switch
                      name="stock_tracking"
                      checked={product.stock_tracking}
                      onChange={this.handleChange}
                      value={product.stock_tracking}
                    />
                  </div>
                  <Divider className={classes.divider} />
                  <div className={classes.containerSwitch}>
                    <LabelForm label={t("product_preorder")} />
                    <Switch
                      name="stock_preorder"
                      checked={product.stock_preorder}
                      onChange={this.handleChange}
                      value={product.stock_preorder}
                    />
                  </div>
                  <Divider className={classes.divider} />
                  <div className={classes.containerSwitch}>
                    <LabelForm label={t("product_backorder")} />
                    <Switch
                      name="stock_backorder"
                      checked={product.stock_backorder}
                      onChange={this.handleChange}
                      value={product.stock_backorder}
                    />
                  </div>
                  <Divider className={classes.divider} />
                  <div className={classes.containerSwitch}>
                    <LabelForm label={t("product_discontinued")} />
                    <Switch
                      name="discontinued"
                      checked={product.discontinued}
                      onChange={this.handleChange}
                      value={product.discontinued}
                    />
                  </div>
                  <Divider className={classes.divider} />
                  <div className={classes.containerSwitch}>
                    <LabelForm label={t("product_enabled")} />
                    <Switch
                      name="enabled"
                      checked={product.enabled}
                      onChange={this.handleChange}
                      value={product.enabled}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </MuiPickersUtilsProvider>
    );
  }
}
export default translate("translations")(
  withStyles(style, { withTheme: 0 })(Inventory)
);
